/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Motivo per cui una domanda e\' stata saltata nell\'importazione massiva
 */
export enum MotivoSaltoImportazioneEsercente {

    NON_TROVATA = 'NON_TROVATA',

    INCOMPLETA = 'INCOMPLETA',

    GIA_PRESENTE = 'GIA_PRESENTE',

    NESSUN_NEGOZIO = 'NESSUN_NEGOZIO',

    ESERCENTE_BLOCCATO = 'ESERCENTE_BLOCCATO',

    ESERCENTE_ANONIMIZZATO = 'ESERCENTE_ANONIMIZZATO',

    PARTITA_IVA_GIA_CON_DOMANDA = 'PARTITA_IVA_GIA_CON_DOMANDA'
}

